import { defineMessage } from '@lingui/macro';

const REQUESTED = 'REQUESTED',
  PARTIAL_ISSUED = 'PARTIAL_ISSUED',
  ISSUED = 'ISSUED',
  CLOSED = 'CLOSED',
  EXPIRED = 'EXPIRED';

export const RodRequestStatusMessages = {
  [REQUESTED]: defineMessage({ message: `Requested` }),
  [PARTIAL_ISSUED]: defineMessage({ message: `Partial Issued` }),
  [ISSUED]: defineMessage({ message: `Issued` }),
  [CLOSED]: defineMessage({ message: `Closed` }),
  [EXPIRED]: defineMessage({ message: `Expired` }),
};
